import React from 'react';
import infoIconImg from 'images/info.png';
import { NotificationManager } from 'react-notifications';
import renderHTML from 'react-render-html';
import { isTerminal } from 'utils/UiHelper';
import {
    ToolbarContent,
    ToggleIcon,
    ToggleListWrapper,
    ToolbarTitle,
} from './styled';

const ViewToggleListToolbar = ({
    toggleHandler,
    tournamentId,
    opened,
    infoIcon,
    withoutArrow,
    height,
    title,
    titleId,
    type,
}) => {
    const onClickHandler = () => {
        if (toggleHandler) {
            toggleHandler(!isExpand(), tournamentId);
        }
    };

    const isExpand = () => {
        return opened === 'yes';
    };

    const showInfo = (text, e) => {
        NotificationManager.info('', text, 5000);
        e.stopPropagation();
        e.preventDefault();
    };

    const renderInfoIcon = () => {
        return !isTerminal() && infoIcon ? (
            <img
                src={infoIconImg}
                onClick={(e) => showInfo(infoIcon, e)}
                height="13px"
                alt="ingo"
            />
        ) : null;
    };
    let arrow = <i className="fa fa-angle-up" aria-hidden="true" />;

    if (type && type === 'right-arrow') {
        arrow = <i className="fa fa-angle-right" aria-hidden="true" />;
    } else {
        if (!isExpand()) {
            arrow = <i className="fa fa-angle-down" aria-hidden="true" />;
        }
    }
    return (
        <ToggleListWrapper
            id={
                titleId ||
                title
                    .toLowerCase()
                    .split(' ')
                    .join('-')
            }
            height={height}
            expanded={isExpand()}
            onClick={onClickHandler}
        >
            <ToolbarContent>
                <ToolbarTitle
                    $fontSize={withoutArrow ? '16px' : '14px'}
                    $fontWeight={withoutArrow ? 'bold' : 'normal'}
                    $lh={withoutArrow ? '24px' : '20px'}
                >
                    {renderHTML(title)}
                    &nbsp; {renderInfoIcon()}
                </ToolbarTitle>

                {!withoutArrow ? <ToggleIcon> {arrow} </ToggleIcon> : null}
            </ToolbarContent>
        </ToggleListWrapper>
    );
};

export default ViewToggleListToolbar;
